import { Injectable } from "@angular/core";
import { AngularFireAuth } from "angularfire2/auth";
import { AngularFireDatabase } from "angularfire2/database";
import * as firebase from "firebase/app";
import { IUser } from "../shared/models/user.model";
import { ClientData } from "./client";

@Injectable()
export class AuthData {

  public fireAuth: any;

  constructor(
    private afAuth: AngularFireAuth,
    public database: AngularFireDatabase,
    private clientData: ClientData,
  ) {
    this.afAuth.authState.subscribe((user) => {
      if (user) {
        this.fireAuth = user;
      }
    });
  }

  public getUser() {
    return this.afAuth.authState;
  }

  public getUserData() {
    return this.fireAuth;
  }

  public getUserDB(uid: string, clientId: string) {
    return this.database.object<IUser>(`/Clients/${clientId}/Users/${uid}`).valueChanges();
  }

  public getUserBeneficiaries(clientId, userId) {
    return this.database.list<any>(`/Clients/${clientId}/Users/${userId}/UsersBeneficiaries/`).valueChanges();
  }

  public getUserGuest(clientId, userId) {
    return this.database.list<any>(`/Clients/${clientId}/Users/${userId}/UsersGuest/`).valueChanges();
  }

  public getClient(uid) {
    return new Promise((resolve, reject) => {
      firebase.database().ref(`/AdministratorList/${uid}`)
        .once("value")
        .then((user: any) => {
          if (user.val()) {
            this.clientData.getClientConfig(user.val().managerClient)
              .once("value")
              .then((clientConfig) => resolve({
                ...clientConfig.val(),
                user: {
                  ...user.val(),
                  id: uid,
                },
              }));
          } else {
            return reject({ message: "Not found user" });
          }
        });
    });
  }

  public getFbUser(uid) {
    return new Promise((resolve, reject) => {
      firebase.database().ref(`/AdministratorList/${uid}`)
        .once("value")
        .then((user: any) => {
          this.clientData.getClientConfig(user.val().managerClient)
            .once("value")
            .then((clientConfig) => resolve(clientConfig.val()));
        });
    });
  }

  public loginUser(newEmail: string, newPassword: string): any {
    return this.afAuth.auth.signInWithEmailAndPassword(newEmail, newPassword);
  }

  public resetPassword(email: string): any {
    return this.afAuth.auth.sendPasswordResetEmail(email);
  }

  public logoutUser(): any {
    return this.afAuth.auth.signOut();
  }

  public getExactUser(uid, client) {
    return firebase.database().ref(`/Clients/${client.url}/Users/${uid}`);
  }
}
 // end file



// WEBPACK FOOTER //
// ./src/providers/auth.ts